import { useState, useEffect } from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import NativeNumber from '../../component/Numeral';

const StatusCountStyle = styled.div`
	& > * {
		padding: 7px 15px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
`;

interface StatusCount {
	completed: number;
	running: number;
	terminated: number;
}
interface IStatusCount {
	statusCount: StatusCount;
}
const InvestmentStatusCount = ({ statusCount }: IStatusCount) => {
	const [counts, setCounts] = useState<any>({
		running: 0,
		completed: 0,
		terminated: 0,
	});
	useEffect(() => {
		if (statusCount) {
			setCounts({
				running: statusCount?.running,
				completed: statusCount?.completed,
				terminated: statusCount?.terminated,
			});
		}
	}, [statusCount]);

	return (
		<StatusCountStyle>
			<Tag color="yellow">
				<p>Running</p>
				<p>
					<NativeNumber value={counts.running} />
				</p>
			</Tag>
			<Tag color="orange">
				<p>Completed</p>
				<p>
					<NativeNumber value={counts.completed} />
				</p>
			</Tag>
			<Tag color="blue">
				<p>Terminated</p>
				<p>
					<NativeNumber value={counts.terminated} />
				</p>
			</Tag>
		</StatusCountStyle>
	);
};

export default InvestmentStatusCount;
